import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-smart-card',
  templateUrl: './smart-card.component.html',
  styleUrls: ['./smart-card.component.css']
})
export class SmartCardComponent implements OnInit {

  @Input() cardType: 'free' | 'premium' | 'coming-soon' | 'locked' | 'promo' | 'promo-banner' | 'banner'; // Card Type
  @Input() title: string = ''; // Card Title
  @Input() description: string = ''; // Card Description
  @Input() imageUrl: string = ''; // Background/Image
  @Input() status: 'paid' | 'pending' | 'failed' = 'pending'; // Payment Status
  @Input() ctaText: string = 'View'; // Button Text
  @Input() badgeText: string = ''; // Badge Text (e.g., "Premium", "Free")
  @Input() linkUrl: string = ''; // 
  @Input() section: string = ''; // 

  @Output() ctaClicked = new EventEmitter(); // Emit event when CTA is clicked

  constructor() { }

  ngOnInit(): void {
  }

  onCtaClick() {
    let eventObj = { linkUrl: this.linkUrl, section: this.section? this.section : ''}
    this.ctaClicked.emit(eventObj);
  }

}
